import type { ObjectType } from 'src/tpbp-configuration/models/models.const'
import { OBJECT_TYPES } from 'src/tpbp-configuration/models/models.const'
import {
  linesFields,
  linesRelations,
} from 'src/services/mappings/Lines/lines.model'
import {
  advisingReportFields,
  advisingReportRelations,
} from 'src/services/mappings/advisingReport/advisingReport.model'
import {
  bankConnectionFields,
  bankConnectionRelations,
} from 'src/services/mappings/bankConnection/bankConnection.model'
import {
  beneficiariesFields,
  beneficiariesRelations,
} from 'src/tpbp-json-api-handler/models/beneficiaries.model'
import {
  beneficiaryClauseConfigurationFields,
  beneficiaryClauseConfigurationRelations,
} from 'src/services/mappings/beneficiaryClauseConfiguration/beneficiaryClauseConfiguration.model'
import {
  budgetItemFields,
  budgetItemRelations,
} from 'src/services/mappings/budgetItem/budgetItem.model'
import {
  budgetItemConfigurationFields,
  budgetItemConfigurationRelations,
} from 'src/services/mappings/budgetItemConfiguration/budgetItemConfiguration.model'
import {
  callToActionFields,
  callToActionRelations,
} from 'src/services/mappings/callToAction/callToAction.model'
import {
  careersFields,
  careersRelations,
} from 'src/services/mappings/careers/careers.model'
import {
  retirementFundsFields,
  retirementFundsRelations,
} from 'src/services/mappings/careers/retirementFunds.model'
import {
  contractFields,
  contractRelations,
} from 'src/services/mappings/contract/contract.model'
import {
  contractLineFields,
  contractLineRelations,
} from 'src/services/mappings/contractLine/contractLine.model'
import { cspFields, cspRelations } from 'src/services/mappings/csp/csp.model'
import {
  householdFields,
  householdRelations,
} from 'src/services/mappings/household/household.model'
import {
  indicatorFields,
  indicatorRelations,
} from 'src/services/mappings/indicator/indicator.model'
import {
  investorProfilePiSurveyFields,
  investorProfilePiSurveyRelations,
} from 'src/services/mappings/investorProfileSurvey/investorProfilePiSurvey.model'
import {
  investorProfileQceSurveyFields,
  investorProfileQceSurveyRelations,
} from 'src/services/mappings/investorProfileSurvey/investorProfileQceSurvey.model'
import {
  investorRiskProfileFields,
  investorRiskProfileRelations,
} from 'src/services/mappings/investorRiskProfile/investorRiskProfile.model'
import {
  loansFields,
  loansRelations,
} from 'src/services/mappings/loans/loans.model'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import {
  nniDataFields,
  nniDataRelations,
} from 'src/services/mappings/nniData/nniData.model'
import {
  ownershipFields,
  ownershipRelations,
} from 'src/services/mappings/ownership/ownership.model'
import {
  patrimonialIndicatorsFields,
  patrimonialIndicatorsRelations,
} from 'src/services/mappings/patrimonialIndicators/patrimonialIndicators.model'
import {
  pedagogicalContentsFields,
  pedagogicalContentsRelations,
} from 'src/services/mappings/pedagogicalContents/pedagogicalContents.model'
import {
  personFields,
  personRelations,
} from 'src/services/mappings/person/person.model'
import {
  personConfigurationFields,
  personConfigurationRelations,
} from 'src/services/mappings/personConfiguration/personConfiguration.model'
import {
  portfolioFields,
  portfolioRelations,
} from 'src/services/mappings/portfolio/portfolio.model'
import {
  portfolioConfigurationFields,
  portfolioConfigurationRelations,
} from 'src/services/mappings/portfolioConfiguration/portfolioConfiguration.model'
import {
  productsFields,
  productsRelations,
} from 'src/services/mappings/product/product.models'
import {
  productInvestmentsFields,
  productInvestmentsRelations,
} from 'src/services/mappings/productInvestments/productInvestments.model'
import {
  professionFields,
  professionRelations,
} from 'src/services/mappings/profession/profession.model'
import {
  recommendationFields,
  recommendationRelations,
} from 'src/services/mappings/recommendation/recommendation.models'
import {
  relationFields,
  relationRelations,
} from 'src/services/mappings/relation/relation.model'
import {
  relationsMapFields,
  relationsMapRelations,
} from 'src/services/mappings/relationsMap/relationsMap.model'
import {
  previousStepFields,
  previousStepRelations,
} from 'src/services/mappings/study/previousStep.model'
import {
  studyFields,
  studyRelations,
} from 'src/services/mappings/study/study.model'
import {
  studyHistoryFields,
  studyHistoryRelations,
} from 'src/services/mappings/study/studyHistory.model'
import {
  studyReportFields,
  studyReportRelations,
} from 'src/services/mappings/study/studyReport.model'
import {
  studyRetirementComplementaryInfosFields,
  studyRetirementComplementaryInfosRelations,
} from 'src/services/mappings/studyRetirementComplementaryInfos/studyRetirementComplementaryInfos.model'
import {
  trimestersBuybacksFields,
  trimestersBuybacksRelations,
} from 'src/services/mappings/trimestersBuybacks/trimestersBuybacks.model'
import {
  agendaAppointmentFields,
  agendaClientAccessFields,
  agendaClientPhoneNumbersFields,
  agendaContainerFields,
  agendaContainerRelations,
  agendaFinancialAdvisorAvailabilitiesFields,
  agendaFinancialAdvisorAvailabilityDetailsFields,
  agendaFinancialAdvisorsFields,
  agendaNewAppointmentsFields,
  agendaReasonFields,
  agendaTechnicalContextFields,
} from '../agenda/agenda.model'
import { donationFields, donationRelations } from './donation/donation.model'
import {
  donationConfigurationFields,
  donationConfigurationRelations,
} from './donation/donationConfiguration.model'
import {
  donationDoneeFields,
  donationDoneeRelations,
} from './donation/donationDonee.model'
import {
  donationGoodFields,
  donationGoodRelations,
} from './donation/donationGood.model'
import {
  doneeConfigurationFields,
  doneeConfigurationRelations,
} from './donation/doneesConfiguration.model'
import {
  entryCategoryConfigurationFields,
  entryCategoryConfigurationRelations,
} from './entryCategoryConfiguration/entryCategoryConfiguration.model'
import { esgDataFields, esgDataRelations } from './esgDatas/esgDatas.model'
import {
  esgQualificationScoresFields,
  esgQualificationScoresRelations,
} from './esgQualification/esgQualificationScores'
import {
  esgQualificationStepResponsesFields,
  esgQualificationStepResponsesRelations,
} from './esgQualification/esgQualificationStepResponses'
import { estimateFields } from './estimate/estimate.model'
import { estimateTimeseriesFields } from './estimate/estimateTimeseries.model'
import {
  investorProfileEsgSurveyFields,
  investorProfileEsgSurveyRelations,
} from './investorProfileSurvey/investorProfileEsgSurvey.model'
import {
  attributorConfigurationFields,
  attributorConfigurationRelations,
} from './leg/attributorsConfiguration.model'
import { legFields, legRelations } from './leg/leg.model'
import {
  legConfigurationFields,
  legConfigurationRelations,
} from './leg/legConfiguration.model'
import { legGoodFields, legGoodRelations } from './leg/legGood.model'
import {
  legReceiverFields,
  legReceiverRelations,
} from './leg/legReceiver.model'
import {
  receiverConfigurationFields,
  receiverConfigurationRelations,
} from './leg/receiversConfiguration.model'
import {
  piQualificationScoresFields,
  piQualificationScoresRelations,
} from './piQualification/piQualificationScores'
import {
  piQualificationStepResponsesFields,
  piQualificationStepResponsesRelations,
} from './piQualification/piQualificationStepResponses'
import { timeseriesFields } from './portfolio/timeseries.model'
import { transactionFields } from './portfolio/transaction.model'
import {
  productGroupConfigurationFields,
  productGroupConfigurationRelations,
} from './productGroupConfiguration/productGroupConfiguration.model'
import {
  qceQualificationScoresFields,
  qceQualificationScoresRelations,
} from './qceQualification/qceQualificationScores'
import {
  qceQualificationStepResponsesFields,
  qceQualificationStepResponsesRelations,
} from './qceQualification/qceQualificationStepResponses'
import {
  qualificationsFields,
  qualificationsRelations,
} from './qceQualification/qualifications'
import { realEstateHolderFields } from './realestateHolder/realestateHolder.model'
import {
  serializableEstimationDatasFields,
  serializableEstimationDatasRelations,
} from './serializableEstimationDatas/serializableEstimationDatas.model'
import {
  additionalTaxInformationFields,
  additionalTaxInformationRelations,
} from 'src/services/mappings/additional-tax-information/additional-tax-information.model'

export const MAPPING_FIELDS = {
  [OBJECT_TYPES.additionalTaxInformation]: additionalTaxInformationFields,
  [OBJECT_TYPES.advisingReport]: advisingReportFields,
  [OBJECT_TYPES.agendaAppointmentDetails]: agendaAppointmentFields,
  [OBJECT_TYPES.agendaAppointments]: agendaAppointmentFields,
  [OBJECT_TYPES.agendaClientAccesses]: agendaClientAccessFields,
  [OBJECT_TYPES.agendaClientPhoneNumbers]: agendaClientPhoneNumbersFields,
  [OBJECT_TYPES.agendaContainers]: agendaContainerFields,
  [OBJECT_TYPES.agendaFinancialAdvisorAvailabilities]:
    agendaFinancialAdvisorAvailabilitiesFields,
  [OBJECT_TYPES.agendaFinancialAdvisorAvailabilityDetails]:
    agendaFinancialAdvisorAvailabilityDetailsFields,
  [OBJECT_TYPES.agendaFinancialAdvisors]: agendaFinancialAdvisorsFields,
  [OBJECT_TYPES.agendaNewAppointments]: agendaNewAppointmentsFields,
  [OBJECT_TYPES.agendaReasons]: agendaReasonFields,
  [OBJECT_TYPES.agendaTechnicalContexts]: agendaTechnicalContextFields,
  [OBJECT_TYPES.aggregatedSeries]: [],
  [OBJECT_TYPES.bankConnection]: bankConnectionFields,
  [OBJECT_TYPES.beneficiaries]: beneficiariesFields,
  [OBJECT_TYPES.beneficiaryClauseConfiguration]:
    beneficiaryClauseConfigurationFields,
  [OBJECT_TYPES.budgetItem]: budgetItemFields,
  [OBJECT_TYPES.budgetItemConfiguration]: budgetItemConfigurationFields,
  [OBJECT_TYPES.callToAction]: callToActionFields,
  [OBJECT_TYPES.careers]: careersFields,
  [OBJECT_TYPES.contract]: contractFields,
  [OBJECT_TYPES.contractLine]: contractLineFields,
  [OBJECT_TYPES.csp]: cspFields,
  [OBJECT_TYPES.donation]: donationFields,
  [OBJECT_TYPES.donationConfiguration]: donationConfigurationFields,
  [OBJECT_TYPES.donationDonee]: donationDoneeFields,
  [OBJECT_TYPES.donationGood]: donationGoodFields,
  [OBJECT_TYPES.doneesConfiguration]: doneeConfigurationFields,
  [OBJECT_TYPES.entryCategoryConfiguration]: entryCategoryConfigurationFields,
  [OBJECT_TYPES.estimate]: estimateFields,
  [OBJECT_TYPES.estimateTimeseries]: estimateTimeseriesFields,
  [OBJECT_TYPES.genericModel]: [],
  [OBJECT_TYPES.household]: householdFields,
  [OBJECT_TYPES.indicator]: indicatorFields,
  [OBJECT_TYPES.leg]: legFields,
  [OBJECT_TYPES.legConfiguration]: legConfigurationFields,
  [OBJECT_TYPES.legReceiver]: legReceiverFields,
  [OBJECT_TYPES.legGood]: legGoodFields,
  [OBJECT_TYPES.attributorsConfiguration]: attributorConfigurationFields,
  [OBJECT_TYPES.receiversConfiguration]: receiverConfigurationFields,
  [OBJECT_TYPES.lines]: linesFields,
  [OBJECT_TYPES.loans]: loansFields,
  [OBJECT_TYPES.nniData]: nniDataFields,
  [OBJECT_TYPES.ownership]: ownershipFields,
  [OBJECT_TYPES.patrimonialIndicators]: patrimonialIndicatorsFields,
  [OBJECT_TYPES.pedagogicalContents]: pedagogicalContentsFields,
  [OBJECT_TYPES.person]: personFields,
  [OBJECT_TYPES.personConfiguration]: personConfigurationFields,
  [OBJECT_TYPES.personExternalData]: personFields,
  [OBJECT_TYPES.piQualificationScores]: piQualificationScoresFields,
  [OBJECT_TYPES.piQualificationStepResponse]:
    piQualificationStepResponsesFields,
  [OBJECT_TYPES.piSurvey]: investorProfilePiSurveyFields,
  [OBJECT_TYPES.esgData]: esgDataFields,
  [OBJECT_TYPES.esgQualificationScores]: esgQualificationScoresFields,
  [OBJECT_TYPES.esgQualificationStepResponse]:
    esgQualificationStepResponsesFields,
  [OBJECT_TYPES.esgSurvey]: investorProfileEsgSurveyFields,
  [OBJECT_TYPES.portfolio]: portfolioFields,
  [OBJECT_TYPES.portfolioConfiguration]: portfolioConfigurationFields,
  [OBJECT_TYPES.productGroupConfiguration]: productGroupConfigurationFields,
  [OBJECT_TYPES.previousStep]: previousStepFields,
  [OBJECT_TYPES.productInvestments]: productInvestmentsFields,
  [OBJECT_TYPES.products]: productsFields,
  [OBJECT_TYPES.profession]: professionFields,
  [OBJECT_TYPES.qceQualificationScores]: qceQualificationScoresFields,
  [OBJECT_TYPES.qceQualificationStepResponse]:
    qceQualificationStepResponsesFields,
  [OBJECT_TYPES.qceSurvey]: investorProfileQceSurveyFields,
  [OBJECT_TYPES.qualifications]: qualificationsFields,
  [OBJECT_TYPES.realEstateHolder]: realEstateHolderFields,
  [OBJECT_TYPES.recommendation]: recommendationFields,
  [OBJECT_TYPES.relation]: relationFields,
  [OBJECT_TYPES.relationsMap]: relationsMapFields,
  [OBJECT_TYPES.retirementFunds]: retirementFundsFields,
  [OBJECT_TYPES.riskProfile]: investorRiskProfileFields,
  [OBJECT_TYPES.serializableEstimationDatas]: serializableEstimationDatasFields,
  [OBJECT_TYPES.studies]: studyFields,
  [OBJECT_TYPES.studyHistory]: studyHistoryFields,
  [OBJECT_TYPES.studyReport]: studyReportFields,
  [OBJECT_TYPES.studyRetirementComplementaryInfo]:
    studyRetirementComplementaryInfosFields,
  [OBJECT_TYPES.survey]: [],
  [OBJECT_TYPES.timeseries]: timeseriesFields,
  [OBJECT_TYPES.transactions]: transactionFields,
  [OBJECT_TYPES.trimestersBuybacks]: trimestersBuybacksFields,
} satisfies Record<ObjectType, FieldInterface[]> as Record<
  ObjectType,
  FieldInterface[]
>

export const MAPPING_RELATIONS = {
  [OBJECT_TYPES.additionalTaxInformation]: additionalTaxInformationRelations,
  [OBJECT_TYPES.advisingReport]: advisingReportRelations,
  [OBJECT_TYPES.agendaAppointmentDetails]: [],
  [OBJECT_TYPES.agendaAppointments]: [],
  [OBJECT_TYPES.agendaClientAccesses]: [],
  [OBJECT_TYPES.agendaClientPhoneNumbers]: [],
  [OBJECT_TYPES.agendaContainers]: agendaContainerRelations,
  [OBJECT_TYPES.agendaFinancialAdvisorAvailabilities]: [],
  [OBJECT_TYPES.agendaFinancialAdvisorAvailabilityDetails]: [],
  [OBJECT_TYPES.agendaFinancialAdvisors]: [],
  [OBJECT_TYPES.agendaNewAppointments]: [],
  [OBJECT_TYPES.agendaReasons]: [],
  [OBJECT_TYPES.agendaTechnicalContexts]: [],
  [OBJECT_TYPES.aggregatedSeries]: [],
  [OBJECT_TYPES.bankConnection]: bankConnectionRelations,
  [OBJECT_TYPES.beneficiaries]: beneficiariesRelations,
  [OBJECT_TYPES.beneficiaryClauseConfiguration]:
    beneficiaryClauseConfigurationRelations,
  [OBJECT_TYPES.budgetItem]: budgetItemRelations,
  [OBJECT_TYPES.budgetItemConfiguration]: budgetItemConfigurationRelations,
  [OBJECT_TYPES.callToAction]: callToActionRelations,
  [OBJECT_TYPES.careers]: careersRelations,
  [OBJECT_TYPES.contract]: contractRelations,
  [OBJECT_TYPES.contractLine]: contractLineRelations,
  [OBJECT_TYPES.csp]: cspRelations,
  [OBJECT_TYPES.donation]: donationRelations,
  [OBJECT_TYPES.donationConfiguration]: donationConfigurationRelations,
  [OBJECT_TYPES.donationDonee]: donationDoneeRelations,
  [OBJECT_TYPES.donationGood]: donationGoodRelations,
  [OBJECT_TYPES.doneesConfiguration]: doneeConfigurationRelations,
  [OBJECT_TYPES.entryCategoryConfiguration]:
    entryCategoryConfigurationRelations,
  [OBJECT_TYPES.estimate]: [],
  [OBJECT_TYPES.estimateTimeseries]: [],
  [OBJECT_TYPES.genericModel]: [],
  [OBJECT_TYPES.household]: householdRelations,
  [OBJECT_TYPES.indicator]: indicatorRelations,
  [OBJECT_TYPES.leg]: legRelations,
  [OBJECT_TYPES.legConfiguration]: legConfigurationRelations,
  [OBJECT_TYPES.legReceiver]: legReceiverRelations,
  [OBJECT_TYPES.legGood]: legGoodRelations,
  [OBJECT_TYPES.attributorsConfiguration]: attributorConfigurationRelations,
  [OBJECT_TYPES.receiversConfiguration]: receiverConfigurationRelations,
  [OBJECT_TYPES.lines]: linesRelations,
  [OBJECT_TYPES.loans]: loansRelations,
  [OBJECT_TYPES.nniData]: nniDataRelations,
  [OBJECT_TYPES.ownership]: ownershipRelations,
  [OBJECT_TYPES.patrimonialIndicators]: patrimonialIndicatorsRelations,
  [OBJECT_TYPES.pedagogicalContents]: pedagogicalContentsRelations,
  [OBJECT_TYPES.person]: personRelations,
  [OBJECT_TYPES.personConfiguration]: personConfigurationRelations,
  [OBJECT_TYPES.personExternalData]: personRelations,
  [OBJECT_TYPES.piQualificationScores]: piQualificationScoresRelations,
  [OBJECT_TYPES.piQualificationStepResponse]:
    piQualificationStepResponsesRelations,
  [OBJECT_TYPES.piSurvey]: investorProfilePiSurveyRelations,
  [OBJECT_TYPES.esgData]: esgDataRelations,
  [OBJECT_TYPES.esgQualificationScores]: esgQualificationScoresRelations,
  [OBJECT_TYPES.esgQualificationStepResponse]:
    esgQualificationStepResponsesRelations,
  [OBJECT_TYPES.esgSurvey]: investorProfileEsgSurveyRelations,
  [OBJECT_TYPES.portfolio]: portfolioRelations,
  [OBJECT_TYPES.portfolioConfiguration]: portfolioConfigurationRelations,
  [OBJECT_TYPES.productGroupConfiguration]: productGroupConfigurationRelations,
  [OBJECT_TYPES.previousStep]: previousStepRelations,
  [OBJECT_TYPES.productInvestments]: productInvestmentsRelations,
  [OBJECT_TYPES.products]: productsRelations,
  [OBJECT_TYPES.profession]: professionRelations,
  [OBJECT_TYPES.qceQualificationScores]: qceQualificationScoresRelations,
  [OBJECT_TYPES.qceQualificationStepResponse]:
    qceQualificationStepResponsesRelations,
  [OBJECT_TYPES.qceSurvey]: investorProfileQceSurveyRelations,
  [OBJECT_TYPES.qualifications]: qualificationsRelations,
  [OBJECT_TYPES.realEstateHolder]: [],
  [OBJECT_TYPES.recommendation]: recommendationRelations,
  [OBJECT_TYPES.relation]: relationRelations,
  [OBJECT_TYPES.relationsMap]: relationsMapRelations,
  [OBJECT_TYPES.retirementFunds]: retirementFundsRelations,
  [OBJECT_TYPES.riskProfile]: investorRiskProfileRelations,
  [OBJECT_TYPES.serializableEstimationDatas]:
    serializableEstimationDatasRelations,
  [OBJECT_TYPES.studies]: studyRelations,
  [OBJECT_TYPES.studyHistory]: studyHistoryRelations,
  [OBJECT_TYPES.studyReport]: studyReportRelations,
  [OBJECT_TYPES.studyRetirementComplementaryInfo]:
    studyRetirementComplementaryInfosRelations,
  [OBJECT_TYPES.survey]: [],
  [OBJECT_TYPES.timeseries]: [],
  [OBJECT_TYPES.transactions]: [],
  [OBJECT_TYPES.trimestersBuybacks]: trimestersBuybacksRelations,
} satisfies Record<ObjectType, RelationInterface[]> as Record<
  ObjectType,
  RelationInterface[]
>
